// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.title::after {
  height: var(--unit-xxxsm);
  bottom: calc(var(--unit-xxxsm) * -1);
}
ion-header.title ion-title {
  font-weight: 700;
  font-size: var(--unit-lg);
  --color: var(--ion-color-dark);
}
ion-header.title .subtitle {
  padding-inline: var(--unit-lg);
  width: 100%;
}
ion-header.title .subtitle ion-label {
  font-size: var(--font-md);
  font-weight: 400;
  --color: var(--ion-color-info-text);
}

ion-toolbar .close-icon {
  width: 32px;
  height: 32px;
}

.ios-modal ion-toolbar:first-of-type {
  padding-top: 0px !important;
}

.config-title {
  color: var(--ion-color-primary);
}

ion-header ion-toolbar {
  --background: #fff;
}
ion-header ion-toolbar ion-icon {
  margin-right: 16px;
}

ion-header.search {
  background: transparent;
  padding: var(--unit-md);
}
ion-header.search::after {
  background-image: none;
}

ion-content {
  --background: var(--ion-color-primary-contrast);
  --padding-bottom: var(--unit-xxxsm);
}

ion-footer {
  --background: transparent;
}
ion-footer ion-toolbar {
  --border-width: 0;
  --padding-end: 0;
  --padding-start: 0;
  border-top-left-radius: var(--radius-md);
  border-top-right-radius: var(--radius-md);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
}
ion-footer ion-grid ion-button {
  width: auto;
}

#content-schedule {
  padding: 16px 24px;
  background: #fff;
  --padding-bottom: 56px;
}
#content-schedule .title {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#content-schedule hr {
  background: #D8D8D8;
}
#content-schedule ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}
#content-schedule .date-content {
  width: 100%;
  float: none;
  z-index: 9;
}
#content-schedule .time-content {
  width: 100%;
  float: none;
}
#content-schedule .label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}
#content-schedule .label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}
#content-schedule .buttonPWA {
  display: none;
}
#content-schedule .buttonMobile {
  display: block;
}
@media (min-width: 960px) {
  #content-schedule .label-date {
    display: none;
  }
  #content-schedule .label-time {
    display: none;
  }
  #content-schedule .date-content {
    width: 50%;
    float: left;
  }
  #content-schedule .time-content {
    width: 50%;
    float: right;
  }
  #content-schedule .time-pwa {
    padding-top: 12%;
  }
  #content-schedule .buttonPWA {
    display: block;
  }
  #content-schedule .buttonMobile {
    display: none;
  }
}
#content-schedule .boxx-btn {
  text-transform: uppercase;
}
#content-schedule .custom-title {
  color: var(--ion-color-light) !important;
}
#content-schedule .enable-item {
  border-radius: 0px;
  border: none;
}
#content-schedule .enable-item ion-label {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  top: 3px;
}
#content-schedule .enable-item .hour {
  color: #12384F !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  position: relative;
  top: 3px;
}
#content-schedule ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-primary) !important;
  --handle-background: #ffffff !important;
  --handle-background-checked: #fff !important;
}
#content-schedule ion-toggle[slot=end] {
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 0;
}

.ion-footer-time {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  --background: #f8f9fa;
  /* Color de fondo del footer */
}

#container-actions-modal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f0f0f0;
}
#container-actions-modal .cancel,
#container-actions-modal .accept {
  color: var(--ion-color-primary);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
  font-size: 14px !important;
  text-transform: initial;
}
#container-actions-modal .title {
  color: #000;
  text-align: center;
  font-family: "Poppins";
  font-size: 14px !important;
  text-transform: initial;
  font-style: normal;
  font-weight: 590;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/datetime-sheet/datetime-sheet.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,oCAAA;AAAJ;AAGE;EACE,gBAAA;EACA,yBAAA;EACA,8BAAA;AADJ;AAIE;EACE,8BAAA;EACA,WAAA;AAFJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;AAFN;;AAOA;EACE,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,2BAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAQE;EACE,kBAAA;AALJ;AAOI;EACE,kBAAA;AALN;;AAUA;EACE,uBAAA;EACA,uBAAA;AAPF;AASE;EACE,sBAAA;AAPJ;;AAWA;EACE,+CAAA;EACA,mCAAA;AARF;;AAWA;EACE,yBAAA;AARF;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;AARJ;AAYI;EACE,WAAA;AAVN;;AAgBA;EACE,kBAAA;EACA,gBAAA;EAuIA,sBAAA;AAnJF;AAcE;EACI,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZN;AAeE;EACI,mBAAA;AAbN;AAiBE;EACI,cAAA;EACA,mBAAA;AAfN;AAkBE;EACI,WAAA;EACA,WAAA;EACA,UAAA;AAhBN;AAmBE;EACI,WAAA;EACA,WAAA;AAjBN;AAoBE;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AAlBN;AAqBE;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AAnBN;AAsBE;EACI,aAAA;AApBN;AAuBE;EACI,cAAA;AArBN;AAyBE;EACI;IACI,aAAA;EAvBR;EA0BI;IACI,aAAA;EAxBR;EA2BI;IACI,UAAA;IACA,WAAA;EAzBR;EA4BI;IACI,UAAA;IACA,YAAA;EA1BR;EA6BI;IACI,gBAAA;EA3BR;EA8BI;IACI,cAAA;EA5BR;EA+BI;IACI,aAAA;EA7BR;AACF;AAgCE;EACI,yBAAA;AA9BN;AAiCE;EACI,wCAAA;AA/BN;AAkCE;EACI,kBAAA;EACA,YAAA;AAhCN;AAkCM;EACI,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAhCV;AAmCM;EACI,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAjCV;AAqCE;EACI,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AAnCN;AAsCE;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;AApCN;;AAyCA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAtCF;AAwCE;;EAEE,+BAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;AAtCJ;AAyCE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvCJ","sourcesContent":["ion-header.title {\n  &::after {\n    height: var(--unit-xxxsm);\n    bottom: calc(var(--unit-xxxsm) * -1);\n  }\n\n  ion-title {\n    font-weight: 700;\n    font-size: var(--unit-lg);\n    --color: var(--ion-color-dark);\n  }\n\n  .subtitle {\n    padding-inline: var(--unit-lg);\n    width: 100%;\n\n    ion-label {\n      font-size: var(--font-md);\n      font-weight: 400;\n      --color: var(--ion-color-info-text);\n    }\n  }\n}\n\nion-toolbar .close-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.ios-modal ion-toolbar:first-of-type {\n  padding-top: 0px !important;\n}\n\n.config-title {\n  color: var(--ion-color-primary);\n}\n\nion-header {\n  ion-toolbar {\n    --background: #fff;\n\n    ion-icon {\n      margin-right: 16px;\n    }\n  }\n}\n\nion-header.search {\n  background: transparent;\n  padding: var(--unit-md);\n\n  &::after {\n    background-image: none;\n  }\n}\n\nion-content {\n  --background: var(--ion-color-primary-contrast);\n  --padding-bottom: var(--unit-xxxsm);\n}\n\nion-footer {\n  --background: transparent;\n\n  ion-toolbar {\n    --border-width: 0;\n    --padding-end: 0;\n    --padding-start: 0;\n    border-top-left-radius: var(--radius-md);\n    border-top-right-radius: var(--radius-md);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  }\n\n  ion-grid {\n    ion-button {\n      width: auto;\n    }\n  }\n}\n\n\n#content-schedule {\n  padding: 16px 24px;\n  background: #fff;\n\n  .title {\n      color: var(--text-BODY, #2C4051);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n  }\n\n  hr {\n      background: #D8D8D8;\n  }\n\n\n  ion-datetime {\n      margin: 0 auto;\n      background: #f8f9fb;\n  }\n\n  .date-content {\n      width: 100%;\n      float: none;\n      z-index: 9;\n  }\n\n  .time-content {\n      width: 100%;\n      float: none;\n  }\n\n  .label-date {\n      margin-bottom: 0px;\n      margin-left: 16px;\n      font-weight: 500;\n  }\n\n  .label-time {\n      margin-bottom: 0px;\n      margin-left: 16px;\n      font-weight: 500;\n  }\n\n  .buttonPWA {\n      display: none;\n  }\n\n  .buttonMobile {\n      display: block;\n  }\n\n  //PWA\n  @media (min-width: 960px) {\n      .label-date {\n          display: none;\n      }\n\n      .label-time {\n          display: none;\n      }\n\n      .date-content {\n          width: 50%;\n          float: left;\n      }\n\n      .time-content {\n          width: 50%;\n          float: right;\n      }\n\n      .time-pwa {\n          padding-top: 12%;\n      }\n\n      .buttonPWA {\n          display: block;\n      }\n\n      .buttonMobile {\n          display: none;\n      }\n  }\n\n  .boxx-btn {\n      text-transform: uppercase;\n  }\n\n  .custom-title {\n      color: var(--ion-color-light) !important;\n  }\n\n  .enable-item {\n      border-radius: 0px;\n      border: none;\n\n      ion-label {\n          color: #425F81 !important;\n          font-feature-settings: 'liga' off, 'clig' off;\n          font-family: Poppins !important;\n          font-size: 16px !important;\n          font-style: normal;\n          font-weight: 400;\n          line-height: normal;\n          position: relative;\n          top: 3px;\n      }\n\n      .hour {\n          color: #12384F !important;\n          font-feature-settings: 'liga' off, 'clig' off;\n          font-family: Poppins !important;\n          font-size: 16px !important;\n          font-style: normal;\n          font-weight: 500;\n          line-height: normal;\n          position: relative;\n          top: 3px;\n      }\n  }\n\n  ion-toggle {\n      --background: #dfdfdf !important;\n      --background-checked: var(--ion-color-primary) !important;\n      --handle-background: #ffffff !important;\n      --handle-background-checked: #fff !important;\n  }\n\n  ion-toggle[slot=end] {\n      margin-top: 12px;\n      margin-bottom: 12px;\n      padding: 0;\n  }\n  --padding-bottom: 56px;\n}\n\n.ion-footer-time {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  --background: #f8f9fa;\n  /* Color de fondo del footer */\n}\n\n#container-actions-modal {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  border-bottom: 1px solid #f0f0f0;\n\n  .cancel,\n  .accept {\n    color: var(--ion-color-primary);\n    text-align: right;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.4px;\n    font-size: 14px !important;\n    text-transform: initial;\n  }\n\n  .title {\n    color: #000;\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 14px !important;\n    text-transform: initial;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
